import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {
    Breadcrumb,
    Menu,
    Segment,
    Card,
    Header,
    Icon,
    Image,
    Label,
    Message,
    Button, Dropdown
} from 'semantic-ui-react';
import {FormattedNumber} from 'react-intl';
import CustomDivider from '../../components/extras/CustomDivider';
import ExpenseDialog from "../../components/expenses/ExpenseDialog";
import OpenBoxForm from '../../components/open_box/OpenBoxForm';
import OpenTable from '../../components/sale/OpenTable';
import Delivery from './Delivery';
import Orders from './Orders';
import SectionData from "../../data/SectionData";
import {showAlert} from "../../actions/AlertAction";
import {openModalExpense} from "../../actions/ModalExpenseActions";
import {connect} from "react-redux";
import localDB from "../../data/localDB";
import Loading from "../../components/extras/Loading";
import CounterSale from "./CounterSale";
import Tickets from "./Tickets";
import OutstandingBalance from "./OutstandingBalance";
import OtherSales from "./OtherSales";
import Tips from "./Tips";
import CallCenter from "./CallCenter";

const tableIcon = require('../../img/icons/table.svg');
const styles = {
    busy: {
        backgroundColor: '#e44745'
    },
    available: {
        backgroundColor: '#9ccc65'
    }
};

class SalesTable extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            currentSection: null,
            sections: [],
            tables: [],
            is_open: false,
            indexSection: 0,
            loading: true,
            sections_active: true,
            delivery_active: false,
            tickets_active: false,
            balances_active: false,
            other_sales_active: false,
            tips_active: false,
            call_center_active: false,
            orders_active: true,
            counter_sale_active: false,
            ticket_service: localDB.get('store_settings').ticket_service,
        };
        this.openTable = this.openTable.bind(this);
        this.updateTable = this.updateTable.bind(this);
        this.openBoxSubmit = this.openBoxSubmit.bind(this);
        this.handleAddExpense = this.handleAddExpense.bind(this);
        this.handleSectionItemClick = this.handleSectionItemClick.bind(this);
        this.handleOtherSalesItemClick = this.handleOtherSalesItemClick.bind(this);
        this.toggleOffAll = this.toggleOffAll.bind(this);
    }

    componentWillMount(){
        this.initialFetch();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open_table.data){
            let index_section = this.state.data.findIndex((section) => {
                return section.table.find((table) => table.id === nextProps.open_table.data.sale.table.id);
            });
            let index_table = this.state.data.find((section) => {
                return section.table.find((table) => table.id === nextProps.open_table.data.sale.table.id);
            }).table.findIndex((table) => table.id === nextProps.open_table.data.sale.table.id);
            this.updateTable(nextProps.open_table.data, index_table, index_section);
        }

        if(nextProps.update_table.data){
            let index_section = this.state.data.findIndex((section) => {
                return section.table.find((table) => table.id === nextProps.update_table.data.table.id);
            });
            let index_table = this.state.data.find((section) => {
                return section.table.find((table) => table.id === nextProps.update_table.data.table.id);
            }).table.findIndex((table) => table.id === nextProps.update_table.data.table.id);
            let table = this.state.data[index_section].table[index_table];
            table.sale.total = nextProps.update_table.data.total;
            this.updateTable(table, index_table, index_section);
        }
    }

    initialFetch() {
        SectionData.listTables().then(data=>{
            this.setState({ data, is_open: !!data });
            if(data){
                this.menuSections();
            }
            let navigation = localDB.get('navigation_sale');
            if (navigation === 'delivery') {
                this.handleDeliveryItemClick();
            } else if (navigation === 'orders') {
                this.handleOrdersItemClick();
            } else if (navigation === 'counter_sale') {
                this.handleCounterSaleItemClick();
            } else if (navigation === 'tickets') {
                this.handleTicketsItemClick();
            }else if (navigation === 'tips') {
                this.handleTipsItemClick();
            }else if (navigation === 'call_center') {
                this.handleCallCenterItemClick();
            } else if (navigation === 'balances') {
                this.handleBalancesItemClick();
            } else {
                if(data){
                    this.handleSectionItemClick(data[0], 0);
                }else{
                    this.handleCounterSaleItemClick();
                }
            }
        }).finally(() => this.setState({ loading: false }));
    };

    handleAddExpense = () => {
        this.props.openModalExpense({show:true, expense:null});
    };

    handleSectionItemClick(section, index) {
        this.toggleOffAll(section);
        this.setState({indexSection: index, sections_active: true});
        this.makeTables(section.table);
        localDB.set('navigation_sale', 'sections');
    };

    handleDeliveryItemClick = () => {
        let section = {
            name: 'Delivery',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({delivery_active: true});
        localDB.set('navigation_sale', 'delivery');
    };

    handleCounterSaleItemClick = () => {
        let section = {
            name: 'En Mostrador',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({counter_sale_active: true});
        localDB.set('navigation_sale', 'counter_sale');
    };

    handleOrdersItemClick = () => {
        let section = {
            name: 'Pedidos',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({orders_active: true});
        localDB.set('navigation_sale', 'orders');
    };

    handleCallCenterItemClick = () => {
        let section = {
            name: '',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({call_center_active: true});
        localDB.set('navigation_sale', 'call_center');
    };

    handleTicketsItemClick = () => {
        let section = {
            name: '',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({tickets_active: true});
        localDB.set('navigation_sale', 'tickets');
    };

    handleBalancesItemClick = () => {
        let section = {
            name: '',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({balances_active: true});
        localDB.set('navigation_sale', 'balances');
    };

    handleOtherSalesItemClick = () => {
        let section = {
            name: '',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({other_sales_active: true});
        localDB.set('navigation_sale', 'other_sales');
    };

    handleTipsItemClick = () => {
        let section = {
            name: '',
            tables: []
        };
        this.toggleOffAll(section);
        this.setState({tips_active: true});
        localDB.set('navigation_sale', 'tips');
    };


    toggleOffAll(section) {
        this.setState({
            sections_active: false,
            orders_active: false,
            delivery_active: false,
            counter_sale_active:false,
            balances_active: false,
            tickets_active: false,
            other_sales_active: false,
            call_center_active: false,
            tips_active: false,
            currentSection: section
        });
    };

    menuSections() {
        let sections = this.state.data.map(function (section, i) {
            return (
                <Menu.Item
                    name={section.name}
                    onClick={() => this.handleSectionItemClick(section, i)}
                    key={section.id}
                />
            )
        }, this);
        this.setState({sections});
    };

    openBoxSubmit = () => {
        this.initialFetch();
    };

    openTable = (response, index) => {
        if (response.is_busy) {
            localDB.saveSaleStorage(response.sale, 'sale');
            this.props.history.push(`/sale/view/${response.number}`);
        } else {
            this.refs.dialogOpenTable.handleOpen(response, index);
        }
    };

    updateTable = (table, index_table, index_section) => {
        let data = this.state.data;
        data[index_section].table[index_table] = table;
        this.setState(data);
        this.makeTables(this.state.currentSection.table);
    };

    makeTables = (data) => {
        let tables = data.map(function (table, index) {
            return (
                <Card key={table.id} onClick={() => this.openTable(table, index)}
                      style={table.is_busy ? styles.busy : styles.available}>
                    <Card.Content>
                        {table.is_busy ?
                            <Label attached='bottom'>
                                $<FormattedNumber value={table.sale.total.balance} currency="USD" maximumFractionDigits={0}
                                                  minimumFractionDigits={0}/>
                            </Label>
                            : <Label attached='bottom'>Disponible</Label>}
                        <Header as='h5' icon>
                            <Icon><Image src={tableIcon} alt='logo' width={38}/></Icon>
                            {table.number}
                        </Header>
                    </Card.Content>
                </Card>
            )
        }, this);
        this.setState({tables});
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Bisttros - Vender</title>
                </Helmet>
                <Breadcrumb size='large'>
                    <Breadcrumb.Section active>Vender</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {
                    this.state.loading ? <Loading/> : this.state.is_open ?
                        <Segment attached='bottom'>
                            {this.state.currentSection ?
                                <div>
                                    <Menu>
                                        {this.state.sections}
                                        <Menu.Item>
                                            <Button.Group color='orange'>
                                                <Dropdown pointing text='Otras Ventas' icon='shopping basket' floating labeled button className='icon'>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => this.handleCounterSaleItemClick()} icon='shopping bag' content='En Mostrador' />
                                                        <Dropdown.Item onClick={() => this.handleDeliveryItemClick()} icon='truck' content='Delivery'/>
                                                        <Dropdown.Item onClick={() => this.handleOrdersItemClick()} icon='calendar check outline' content='Pedidos'/>
                                                        <Dropdown.Item onClick={() => this.handleCallCenterItemClick()} icon='phone' content='Call Center'/>
                                                        {this.state.ticket_service ? <Dropdown.Item onClick={() => this.handleTicketsItemClick()} icon='ticket' content='Tiqueteras'/>:null}
                                                        <Dropdown.Item onClick={() => this.handleBalancesItemClick()} icon='dollar' content='Saldos Pendientes'/>
                                                        <Dropdown.Item onClick={() => this.handleTipsItemClick()} icon='gift' content='Propinas'/>
                                                        <Dropdown.Item onClick={() => this.handleOtherSalesItemClick()} icon='money' content='Otros Ingresos'/>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Button.Group>
                                        </Menu.Item>
                                        <Menu.Item position='right'>
                                            <Button.Group>
                                                <Dropdown pointing text='Otras Opciones' icon='cogs' floating labeled button className='icon'>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={this.handleAddExpense} icon='money' content='Agregar Gasto'/>
                                                        <Dropdown.Item as={Link} to='/sale/products' icon='shopping basket' content='Productos Vendidos'/>
                                                        <Dropdown.Item as={Link} to='/sale/stock' icon='coffee' content='Ver Inventario'/>
                                                        {localDB.get('store_security').can_view_box ? <Dropdown.Item as={Link} to='/sale/close' label={{ color: 'orange', empty: true, circular: true }} text='Cerrar Caja' />:null}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Button.Group>
                                        </Menu.Item>
                                    </Menu>
                                    <Header as='h2'>{this.state.currentSection.name}</Header>
                                    {
                                        this.state.sections_active ?
                                            this.state.tables.length === 0 ?
                                                <Message icon='bell' header='No hay mesas registradas'/> :
                                                <Card.Group itemsPerRow={4} stackable>
                                                    {this.state.tables}
                                                </Card.Group> : this.state.delivery_active ?
                                            <Delivery/> : this.state.orders_active ?
                                                <Orders/> : this.state.counter_sale_active ?
                                                    <CounterSale/>:this.state.tickets_active ?
                                                        <Tickets />:this.state.balances_active ? <OutstandingBalance/>:this.state.other_sales_active ? <OtherSales />:this.state.tips_active ? <Tips />:this.state.call_center_active ? <CallCenter/>:null
                                    }
                                </div> : <Message icon='bell' header='No hay secciones registradas'/>
                            }
                        </Segment>
                        : <OpenBoxForm callbackOpen={this.openBoxSubmit}/>
                }
                <OpenTable ref="dialogOpenTable" callbackOpenTable={this.openTable}/>
                <ExpenseDialog location='open_box'/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        open_table: state.get('open_table'),
        update_table: state.get('update_table'),
    };
};

function mapDispatchToProps(dispatch) {
    return {
        openModalExpense(modal){
            dispatch(openModalExpense(modal))
        },
        showAlert(alert){
            dispatch(showAlert(alert))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SalesTable)


// WEBPACK FOOTER //
// ./src/containers/sale/SalesTable.js